
import { LOGIN, GET_LOGIN_DATA, CHANGE_PASSWORD,RESET_PASSWORD,VERIFY_OTP,RESEND_OTP } from '../lib/constants/api-urls';
import Api from "../lib/api-call";

export class LoginService {

  static instance;
  

  static getInstance() {
    if (!LoginService.instance) {
      LoginService.instance = new LoginService();
    }
    return LoginService.instance;
  }
  tryLogin = async (params) => {

    if(params.action && params.action==='resend'){
      return await Api.post(RESEND_OTP.URL, params);
    }else{
      return await Api.post(LOGIN.URL, params);
    }

  }

  fetchLoginData = async (params) => {
    let newsResponse = await Api.get(GET_LOGIN_DATA.URL, params);
    return newsResponse;
  }

  changePassword = async (params) => {
    let newsResponse = await Api.post(CHANGE_PASSWORD.URL, params);
    return newsResponse;
  }

  resetPassword = async (params) => {
    let newsResponse = await Api.put(RESET_PASSWORD.URL, params);
    return newsResponse;
  }

  verifyOtp = async (params) => {
    let newsResponse = await Api.post(`${VERIFY_OTP.URL}`, params);
    return newsResponse;
  }




}